aircraft_translations = {
	product_information: {
		en: "Product Information",
		cn: "产品信息",
		es: "Información del producto",
		pt: "Informações sobre o produto",
		ru: "Информация о продукции"
	},
	// ALT TEXT FOR IMAGERY:
	"gulfstream_g800_in_flight.": {
		en: "Gulfstream G800 in flight.",
		cn: "湾流G800在飞行中。",
		es: "Gulfstream G800 volando.",
		pt: "Gulfstream G800 em voo.",
		ru: "Gulfstream G800 в полете."
	},
	"gulfstream_g700_in_flight.": {
		en: "Gulfstream G700 in flight.",
		cn: "湾流G700在飞行中。",
		es: "Gulfstream G700 volando.",
		pt: "Gulfstream G700 em voo.",
		ru: "Gulfstream G700 в полете."
	},
	"gulfstream_g650er_over_water.": {
		en: "Gulfstream G650ER over water.",
		cn: "湾流G650ER飞过水面。",
		es: "Gulfstream G650ER sobre el agua.",
		pt: "Gulfstream G650ER sobre a água.",
		ru: "Gulfstream G650ER над водой."
	},
	"gulfstream_g600_over_the_coastline.": {
		en: "Gulfstream G600 over the coastline.",
		cn: "湾流G600越过海岸线。",
		es: "Gulfstream G600 sobre la costa.",
		pt: "Gulfstream G600 sobre a costa.",
		ru: "Gulfstream G600 над побережьем."
	},
	"gulfstream_g500_over_water.": {
		en: "Gulfstream G500 over water.",
		cn: "湾流G500飞过水面。",
		es: "Gulfstream G500 sobre el agua.",
		pt: "Gulfstream G500 sobre a água.",
		ru: "Gulfstream G500 над водой."
	},
	"gulfstream_g400_in_flight.": {
		en: "Gulfstream G400 in flight.",
		cn: "湾流G400在飞行中。",
		es: "Gulfstream G400 volando.",
		pt: "Gulfstream G400 em voo.",
		ru: "Gulfstream G400 в полете."
	},
	"gulfstream_g280_on_the_runway.": {
		en: "Gulfstream G280 on the runway.",
		cn: "湾流G280在跑道上。",
		es: "Gulfstream G280 en la pista.",
		pt: "Gulfstream G280 na pista.",
		ru: "Gulfstream G280 на взлетно-посадочной полосе."
	},
	g800_news: {
		en: "G800 News",
		cn: "G800 资讯",
		es: "NOTICIAS DEL G800",
		pt: "NOTÍCIAS SOBRE A AERONAVE G800",
		ru: "НОВОСТИ О G800"
	},
	g700_news: {
		en: "G700 News",
		cn: "G700 资讯",
		es: "NOTICIAS DEL G700",
		pt: "NOTÍCIAS SOBRE A AERONAVE G700",
		ru: "НОВОСТИ О G700"
	},
	g600_news: {
		en: "G600 News",
		cn: "G600 资讯",
		es: "NOTICIAS DEL G600",
		pt: "NOTÍCIAS SOBRE A AERONAVE G600",
		ru: "НОВОСТИ О G600"
	},
	g500_news: {
		en: "G500 News",
		cn: "G500 资讯",
		es: "NOTICIAS DEL G500",
		pt: "NOTÍCIAS SOBRE A AERONAVE G500",
		ru: "НОВОСТИ О G500"
	},
	g400_news: {
		en: "G400 News",
		cn: "G400 资讯",
		es: "NOTICIAS DEL G400",
		pt: "NOTÍCIAS SOBRE A AERONAVE G400",
		ru: "НОВОСТИ О G400"
	},
	g280_news: {
		en: "G280 News",
		cn: "G280 资讯",
		es: "NOTICIAS DEL G280",
		pt: "NOTÍCIAS SOBRE A AERONAVE G280",
		ru: "НОВОСТИ О G280"
	},
	g800_product_information: {
		en: "G800 Product Information",
		cn: "G800 产品信息",
		es: "INFORMACIÓN DEL PRODUCTO G800",
		pt: "INFORMAÇÕES DE PRODUTO DA G800",
		ru: "G800: ИНФОРМАЦИЯ О ПРОДУКЦИИ"
	},
	g700_product_information: {
		en: "G700 Product Information",
		cn: "G700 产品信息",
		es: "INFORMACIÓN DEL PRODUCTO G700",
		pt: "INFORMAÇÕES DE PRODUTO DA G700",
		ru: "G700: ИНФОРМАЦИЯ О ПРОДУКЦИИ"
	},
	g600_product_information: {
		en: "G600 Product Information",
		cn: "G600 产品信息",
		es: "INFORMACIÓN DEL PRODUCTO G600",
		pt: "INFORMAÇÕES DE PRODUTO DA G600",
		ru: "G600: ИНФОРМАЦИЯ О ПРОДУКЦИИ"
	},
	g500_product_information: {
		en: "G500 Product Information",
		cn: "G500 产品信息",
		es: "INFORMACIÓN DEL PRODUCTO G500",
		pt: "INFORMAÇÕES DE PRODUTO DA G500",
		ru: "G500: ИНФОРМАЦИЯ О ПРОДУКЦИИ"
	},
	g400_product_information: {
		en: "G400 Product Information",
		cn: "G400 产品信息",
		es: "INFORMACIÓN DEL PRODUCTO G400",
		pt: "INFORMAÇÕES DE PRODUTO DA G400",
		ru: "G400: ИНФОРМАЦИЯ О ПРОДУКЦИИ"
	},
	g280_product_information: {
		en: "G280 Product Information",
		cn: "G280 产品信息",
		es: "INFORMACIÓN DEL PRODUCTO G280",
		pt: "INFORMAÇÕES DE PRODUTO DA G280",
		ru: "G280: ИНФОРМАЦИЯ О ПРОДУКЦИИ"
	},
	aircraft_info_g800: {
		en: "Able to cover 8,200 nautical miles/15,186 kilometers at Mach 0.85, the Gulfstream G800™ is the world’s longest range business aircraft. Combining high-speed performance and next-generation technology with unmatched cabin comfort, the G800 is easily capable of flying an unprecedented 7,000 nm/12,964 km at Mach 0.90. All-new, high-thrust Rolls-Royce engines, an advanced high-speed wing, and a state-of-the-art fuselage deliver class-leading fuel-efficiency and reduced emissions.",
		cn: "",
		es: "",
		pt: "",
		ru: ""
	},
	aircraft_info_g700: {
		en: "The Gulfstream G700™ combines the industry’s most spacious cabin with record-setting performance. The award-winning interior features the lowest cabin altitude and largest windows in business aviation and accommodates up to 19 passengers in exceptional comfort. Gulfstream’s advanced wing and winglet team up with Rolls-Royce Pearl 700 engines and the award-winning Gulfstream Symmetry Flight Deck™ to improve safety and efficiency while delivering ultralong range and high speed: 7,750 nautical miles/14,353 kilometers at Mach 0.85 or 6,650 nm/12,316 km at Mach 0.90, plus a maximum operating speed of Mach 0.935.",
		cn: "",
		es: "",
		pt: "",
		ru: ""
	},
	aircraft_info_g600: {
		en: "The award-winning Gulfstream G600™ offers world-class speed and range along with exceptional comfort. Powered by fuel-efficient engines and equipped with advanced technology including the Symmetry Flight Deck™, the G600 can fly 6,600 nm/12,223 km at Mach 0.85 or 5,600 nm/10,371 km at Mach 0.90 and has a maximum operating speed of Mach 0.925. The G600 cabin can be configured with up to four living areas and provides the Gulfstream Cabin Experience with fresh air, a low cabin altitude and abundant natural light from 14 Gulfstream Panoramic Oval Windows for up to 19 passengers.",
		cn: "",
		es: "",
		pt: "",
		ru: ""
	},
	aircraft_info_g500: {
		en: "The Gulfstream G500™ introduced the Symmetry Flight Deck to the business-aviation industry when it entered service in September 2018. The aircraft accommodates three distinct living areas and features 14 large Gulfstream panoramic windows and the Gulfstream Cabin Experience. The G500 flies 5,300 nm/9,816 km at Mach 0.85 and 4,500 nm/8,334 km at Mach 0.90.",
		cn: "在2018年9月投入使用时，Gulfstream G500™把和谐驾驶舱（Symmetry Flight Deck）引入了公务航空行业。该飞机可容纳三个不同的生活区，它的特色是拥有14个大型Gulfstream全景舷窗和Gulfstream机舱体验。G500可以0.85马赫飞行9,816公里（5,300海里），或以0.90马赫飞行8,334公里（4,500海里）。",
		es: "El Gulfstream G500™ presentó la Symmetry Flight Deck a la industria de aviación ejecutiva cuando entró en servicio en septiembre de 2018. La aeronave tiene hasta tres áreas de estar diferentes y ofrece 14 grandes ventanillas panorámicas y la experiencia de cabina Gulfstream. El G500 vuela 9816 km (5300 nm) a Mach 0,85 y 8334 km (4500 nm) a Mach 0,90.",
		pt: "O Gulfstream G500™ introduziu o Symmetry Flight Deck ao setor de aviação executiva quando entrou em serviço, em setembro de 2018. A aeronave acomoda três áreas de estar distintas, e apresenta 14 grandes janelas panorâmicas Gulfstream e a Gulfstream Cabin Experience (cabine da Gulfstream). A G500 voa 9.816 km (5.300 nm) a Mach 0,85 e 8.334 km (4.500 nm) a Mach 0,90.",
		ru: "Модель Gulfstream G500™ была введена в эксплуатацию в сентябре 2018 года и стала первой моделью в деловой авиации, оснащенной кабиной экипажа Symmetry Flight Deck. Самолет имеет три отдельные пассажирские зоны, 14 больших панорамных иллюминаторов Gulfstream и фирменный салон Gulfstream. G500 способен преодолеть 9816 км (5300 морских миль) со скоростью 0,85 Маха и 8334 км (4500 морских миль) со скоростью 0,90 Маха."
	},
	aircraft_info_g400: {
		en: "A large-cabin business jet with larger-than-life performance, the Gulfstream G400™ flies farther faster than other aircraft in its class, traveling 4,200 nm/7,778 km at Mach 0.85 and 3,950 nm/7,315 km at Mach 0.88. This remarkable aircraft features an advanced combination of high-speed performance, range and cabin comfort thanks to the award-winning Gulfstream Symmetry Flight Deck, twin Pratt & Whitney engines and 2.5 living areas with space for up to 12 passengers to enjoy the signature relaxing, productivity-boosting Gulfstream Cabin Experience.",
		cn: "作为一款具有非凡性能的大客舱公务喷气机，Gulfstream G400™能比其他同级别飞机飞得更快更远，以0.85马赫飞行7,778公里（4,200海里），以0.88马赫飞行7,315公里（3,950海里）。这款非凡的飞机完美融合了高速性能、航程和客舱舒适性，因为它有屡获殊荣的Gulfstream和谐驾驶舱（Symmetry Flight Deck）、两台普惠发动机和2.5个可容纳12名乘客的生活区，使乘客能享受标志性的轻松、高效的Gulfstream客舱体验。",
		es: "El Gulfstream G400™, un jet ejecutivo de cabina grande con un rendimiento espectacular, vuela más rápido que cualquier otra aeronave en su categoría, viajando hasta 7778 km (4200 nm) a Mach 0,85 y 7315 km (3950 nm) a Mach 0,88. Esta asombrosa aeronave se destaca por su avanzada combinación de rendimiento de alta velocidad, alcance y confort de cabina, gracias a la premiada Symmetry Flight Deck de Gulfstream, dos motores Pratt & Whitney y 2,5 áreas de estar donde 12 pasajeros podrán disfrutar de la singular, relajante y productiva experiencia de la cabina Gulfstream.",
		pt: "Um jato executivo de cabine grande e desempenho excepcional, o Gulfstream G400™ voa mais longe e mais rápido que outras aeronaves de sua categoria, viajando 7.778 km (4.200 nm) a Mach 0,85 e 7.315 km (3.950 nm) a Mach 0,88. Essa aeronave incrível apresenta uma combinação avançada de alta velocidade, alcance e conforto de cabine graças ao premiado Symmetry Flight Deck da Gulfstream, motores Pratt & Whitney gêmeos e duas áreas e meia de estar com espaço suficiente para que até 12 passageiros relaxem e trabalhem com mais produtividade graças à Gulfstream Cabin Experience (cabine da Gulfstream).",
		ru: "Gulfstream G400™ — это крупногабаритный самолет деловой авиации с превосходными летно-техническими характеристиками. Он может летать быстрее на более дальние расстояния, чем другие самолеты этого класса, преодолевая 7778 км (4200 морских миль) со скоростью 0,85 Маха и 7315 км (3950 морских миль) со скоростью 0,88 Маха. Этот замечательный самолет отличается передовым сочетанием высокоскоростных характеристик, дальности полета и комфорта в салоне благодаря отмеченной наградами Gulfstream Symmetry Flight Deck, двум двигателям Pratt & Whitney и 2,5 пассажирскими зонами фирменного салона Gulfstream, в котором с комфортом могут разместиться до 12 пассажиров."
	},
	aircraft_info_g280: {
		en: "The Gulfstream G280™ is a super-midsize jet that performs like a much larger aircraft yet offers the best fuel efficiency in its class. The G280 easily accommodates up to 10 passengers in two distinct living areas with sleeping for five. The cabin features 19 large, oval windows, 100% fresh, never recirculated air and a rejuvenating low cabin altitude along with high-speed communication equipment and media systems. The G280’s maximum operating speed is Mach 0.85.",
		cn: "Gulfstream G280™是一款性能堪比大型公务喷气机的超中型飞机，并拥有领先于同级机型的高燃油效率。G280可设置2个独立的起居区，轻松容纳10名乘客，卧铺数多达5个。其客舱配有19个大尺寸椭圆形舷窗，提供100%永不重复循环的新鲜空气和令人神清气爽的低客舱压力高度，以及高速通信设备和媒体系统。G280的最大飞行速度为0.85马赫。",
		es: "El Gulfstream G280™ es un jet supermediano que tiene un rendimiento parecido al de una aeronave más grande, e incluso así, ofrece la mejor eficiencia de combustible de su clase. El G280 fácilmente aloja hasta 10 pasajeros en dos áreas de estar distintas, con espacio para dormir para cinco personas. La cabina cuenta con 19 ventanas ovaladas grandes, aire fresco al 100 % nunca recirculado y una rejuvenecedora altitud de cabina baja con equipos de comunicación de alta velocidad y sistemas de medios. La velocidad de operación máxima del G280 es Mach 0,85.",
		pt: "A aeronave Gulfstream G280™ é um jato supermédio cujo desempenho se semelha ao de uma aeronave muito maior, oferecendo ainda a melhor eficiência de combustível da categoria. A G280 acomoda confortavelmente até 10 passageiros em dois ambientes de estar com leitos para até cinco pessoas. A cabine tem 19 janelas grandes e ovais, 100% de ar fresco e nunca recirculado, além de uma baixa e revigorante altitude de cabine, com equipamentos de comunicação de alta velocidade e sistemas de mídia. A velocidade operacional máxima da G280 é de Mach 0,85.",
		ru: "Gulfstream G280™ — это суперсреднегабаритный самолет, который по своим летно-техническим характеристикам аналогичен гораздо более крупным моделям, но при этом обеспечивает самую высокую эффективность расхода топлива в своем классе. В G280 можно легко разместить до 10 пассажиров в двух отдельных зонах, включающих пять спальных мест. Салон имеет 19 больших панорамных иллюминаторов и оснащен оборудованием высокоскоростной связи и мультимедийными системами. Также в салоне обеспечивается полностью приточная вентиляция без рециркуляции воздуха и комфортная «условная высота». Максимальная эксплуатационная скорость G280 составляет 0,85 Маха."
	}
};
